export const defaultInputState = {
  errorMessage: '',
  isValid: false,
  maskedValue: '',
  showError: false,
  value: ''
}
